/**
 * Module-local Fabric.js import.
 *
 * Fabric's UMD bundle assigns `window.fabric = fabric` on first require.
 * BugHerd's sidebar runs in the host page's JS context, so that assignment
 * clobbers any Fabric the host page already loaded (e.g. Craft CMS ships
 * Fabric 1.7.22 whose `image.getHeight()` API was removed in Fabric 2+).
 *
 * This shim snapshots whatever `window.fabric` was before we required
 * Fabric and restores it afterwards, while exporting BugHerd's Fabric
 * for our own modules to use.
 *
 * IMPORTANT: this file uses `require('fabric')` deliberately. ESM `import`
 * statements are hoisted by the bundler, which would cause the host
 * snapshot to be captured *after* Fabric ran its global assignment.
 */

type FabricModule = typeof import('fabric');

const hostHadFabric = Reflect.apply(Object.prototype.hasOwnProperty, window, [
  'fabric'
]);
const hostFabric = (window as { fabric?: unknown }).fabric;

// eslint-disable-next-line @typescript-eslint/no-var-requires
const bugherdFabricModule: FabricModule = require('fabric');

if (hostHadFabric) {
  (window as { fabric?: unknown }).fabric = hostFabric;
} else {
  Reflect.deleteProperty(window, 'fabric');
}

export const fabric = bugherdFabricModule.fabric;
